import { render, staticRenderFns } from "./delShopDialog.vue?vue&type=template&id=68e9d552&scoped=true"
import script from "./delShopDialog.vue?vue&type=script&lang=js"
export * from "./delShopDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e9d552",
  null
  
)

export default component.exports